import InfoDealer from './info-dealer';

export default InfoDealer;
export { InfoDealer };
